// extracted by mini-css-extract-plugin
var _1 = "ListItem-modulelistItem__scph2";
export { _1 as "listItem" }
